// @flow
import Radio from 'common/domain/radio';

import { MetricsQuery } from '../domain/Metrics';
import ReachApi from './reachApi';
import MetricsService from './MetricsService';

async function fetchReachMetrics(radio: Radio, token: string, query: MetricsQuery) {
  const { callSign } = radio;

  const [totalReach, averageTotalReach, averageQuarterHourReach, reachByInterval] =
    await Promise.all([
      fetchTotalReach(callSign, token, query),
      fetchAverageTotalReach(callSign, token, query),
      fetchAverageQuarterReach(callSign, token, query),
      fetchReachByInterval(callSign, token, query),
    ]);

  const missingSampling = await fetchMissingSampling(radio, token, query);
  return {
    missingSampling, totalReach, averageTotalReach, averageQuarterHourReach, reachByInterval,
  };
}

async function fetchMissingSampling(radio, token, query) {
  try {
    return await MetricsService.fetchIsMissingSampling(radio, token, query);
  } catch (e) {
    return false; // we do not want to throw error if good metrics
  }
}


async function fetchTotalReach(callSign, token, query) {
  const { dateRange, dateRangeCompared, days, interval, centralMarket } = query;

  const data = dateRangeCompared ?
    ReachApi.getTotalReachCompared(callSign, token, dateRange, dateRangeCompared, interval, days, centralMarket) :
    ReachApi.getTotalReach(callSign, token, dateRange, interval, days, centralMarket);

  return await data;
}

async function fetchAverageTotalReach(callSign, token, query) {
  const { dateRange, dateRangeCompared, days, interval, centralMarket } = query;

  const data = dateRangeCompared ?
    ReachApi.getAverageTotalReachCompared(callSign, token, dateRange, dateRangeCompared, interval, days, centralMarket) :
    ReachApi.getAverageTotalReach(callSign, token, dateRange, interval, days, centralMarket);

  return await data;
}

async function fetchAverageQuarterReach(callSign, token, query) {
  const { dateRange, dateRangeCompared, days, interval, centralMarket } = query;

  const data = dateRangeCompared ?
    ReachApi.getAverageQuarterHourReachCompared(callSign, token, dateRange, dateRangeCompared, interval, days, centralMarket) :
    ReachApi.getAverageQuarterHourReach(callSign, token, dateRange, interval, days, centralMarket);

  return await data;
}

async function fetchReachByInterval(callSign, token, query) {
  const { dateRange, dateRangeCompared, days, interval, centralMarket } = query;

  const data = dateRangeCompared ?
    ReachApi.getReachByIntervalCompared(callSign, token, dateRange, dateRangeCompared, interval, days, centralMarket) :
    ReachApi.getReachByInterval(callSign, token, dateRange, interval, days, centralMarket);

  return await data;
}

export default {
  fetchReachMetrics,
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/services/ReachService.js